<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div style="position: fixed; z-index: 10; width: 100%; top: 0">
  <app-navbar></app-navbar>
</div>
<div class="body" style="padding-top: 10rem">
  <div>
    <!-- <div class="heading-rounds-white">
        <h1><i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i> <span class="headi">CONTACT</span> <i class="fa fa-circle" style="font-size: small; color: #00C4F4;" aria-hidden="true"></i></h1>
    </div> -->
    <div class="heading-rounds-white">
      <h1><span class="headi">CONTACT US</span></h1>
    </div>
    <div class="main-bod">
      <h1 class="col-10">FOR COMPETITION AND PORTAL RELATED QUERIES</h1>
      <div class="criteria col-10">
        <!-- <div class="col-10 contactcard"> -->
        <div class="col-3">
          <span class="text-overlay"></span>
          <span class="grad-overlay"></span>
          <div class="name">
            <h3>Samyak Pahade</h3>
            <h3 id="full-name">Events and PR Head</h3>
          </div>
          <div class="social-icons">
            <div>
              <a
                href="https://www.linkedin.com/in/samyak-pahade-05b605255/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                target="_blank"
                ><i class="fa-brands fa-linkedin-in fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="https://wa.me/917021284560" target="_blank"
                ><i class="fa-brands fa-whatsapp fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="mailto:samyak@ecell.in" target="_blank"
                ><i class="fa fa-envelope fa-2xl"></i
              ></a>
            </div>
          </div>
          <div class="contact-image">
            <img src="https://www.ecell.in/ca/assets/img/santara.jpeg" />
          </div>
        </div>
        <div class="col-3">
          <span class="text-overlay"></span>
          <span class="grad-overlay"></span>
          <div class="name">
            <h3>Bhavesh Tanan</h3>
            <h3 id="full-name">Web & Technical Head</h3>
          </div>
          <div class="social-icons">
            <div>
              <a
                href="https://www.linkedin.com/in/bhaveshtanan/"
                target="_blank"
                ><i class="fa-brands fa-linkedin-in fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="https://wa.me/919460241654" target="_blank"
                ><i class="fa-brands fa-whatsapp fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="mailto:bhavesh@ecell.in" target="_blank"
                ><i class="fa fa-envelope fa-2xl"></i
              ></a>
            </div>
          </div>
          <div class="contact-image">
            <img src="assets/images/bhavesh.png" />
          </div>
        </div>
        
      </div>
   
    
      <h1 class="col-10">FOR SPONSORSHIP QUERIES</h1>
      <div class="criteria col-10">
        <div class="col-3">
          <span class="text-overlay"></span>
          <span class="grad-overlay"></span>
          <div class="name">
            <h3>Advait Kulkarni</h3>
            <h3 id="full-name">Marketing Head</h3>
          </div>
          <div class="social-icons">
            <div>
              <a
                href="https://www.linkedin.com/in/-advait-kulkarni/"
                target="_blank"
                ><i class="fa-brands fa-linkedin-in fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="https://wa.me/917666296418" target="_blank"
                ><i class="fa-brands fa-whatsapp fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="mailto:advait@ecell.in" target="_blank"
                ><i class="fa fa-envelope fa-2xl"></i
              ></a>
            </div>
          </div>
          <div class="contact-image">
            <img src="assets/images/advait.png" />
          </div>
        </div>
        <div class="col-3">
          <span class="text-overlay"></span>
          <span class="grad-overlay"></span>
          <div class="name">
            <h3>Jemima Mathen</h3>
            <h3 id="full-name">Event Coordinator at GII</h3>
          </div>
          <div class="social-icons">
            <div>
              <a
                href="https://www.linkedin.com/in/jemima-mathen-0a71a2219/"
                target="_blank"
                ><i class="fa-brands fa-linkedin-in fa-2xl"></i
              ></a>
            </div>
            <!-- <div>
              <a href="https://wa.me/918910640947" target="_blank"
                ><i class="fa-brands fa-whatsapp fa-2xl"></i
              ></a>
            </div> -->
            <div>
              <a href="mailto:eurekagcc@gii.ae" target="_blank"
                ><i class="fa fa-envelope fa-2xl"></i
              ></a>
            </div>
          </div>
          <div class="contact-image" style=" padding-bottom: 20px;">
            <img src="https://media.licdn.com/dms/image/v2/D4D03AQFFKHocmS-nFg/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1718292926671?e=1738195200&v=beta&t=coeR3YNQSMDy1HGGpeqgfYCH10z8flSrKe99adaCmok" />
          </div>
        </div>
        <!-- <div class="col-3">
          <span class="text-overlay"></span>
          <span class="grad-overlay"></span>
          <div class="name">
            <h3>Prathamesh Yeole</h3>
            <h3 id="full-name">Marketing Head</h3>
          </div>
          <div class="social-icons">
            <div>
              <a
                href="https://www.linkedin.com/in/prathamesh-yeole-426b451b0?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
                ><i class="fa-brands fa-linkedin-in fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="https://wa.me/918484915077" target="_blank"
                ><i class="fa-brands fa-whatsapp fa-2xl"></i
              ></a>
            </div>
            <div>
              <a href="mailto:prathameshy@ecell.in" target="_blank"
                ><i class="fa fa-envelope fa-2xl"></i
              ></a>
            </div>
          </div>
          <div class="contact-image">
            <img src="assets/images/prathamesh.png" />
          </div>
        </div> -->
      </div>

    
      <!-- <div class="struct-heading3">
        <h1>FAQs</h1>
      </div>

      <mat-accordion style="width: 90%" *ngFor="let lis of lis">
        <mat-expansion-panel class="custom-acco">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ lis.ques }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>{{ lis.ans }}</p>
          <p>
            <a href="{{ lis.link }}">{{ lis.link }}</a>
          </p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div> -->
  
  <app-footer></app-footer>
</div>
